import { useState, useEffect, useCallback } from 'react'
import { authenticatedFetchJson } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'
import logger from '../utils/logger'

/**
 * Hook for fetching all billing customer profiles (admin view).
 */
const useBillingProfilesData = () => {
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchProfiles = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await authenticatedFetchJson(apiEndpoints.billingCustomers)
      setCustomers(response?.data || [])
    } catch (err) {
      logger.error('Failed to fetch billing profiles:', err)
      setError(err.message || 'Failed to load billing profiles')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchProfiles()
  }, [fetchProfiles])

  return {
    customers,
    loading,
    error,
    refetch: fetchProfiles
  }
}

export default useBillingProfilesData
